import ActionButton from "../atoms/ActionButton";

// YYYYMMDD → YYYY/MM/DD に変換して表示用にする
const formatDateDisplay = (yyyymmdd) =>
  `${yyyymmdd.slice(0, 4)}/${yyyymmdd.slice(4, 6)}/${yyyymmdd.slice(6, 8)}`;

/**
 * LockPeriodHistoryTable - ロック期間の登録履歴一覧
 *
 * ロック中・解除済みの両方を表示する。二重登録や誤操作に気付きやすくするための一覧。
 * ロック中の行にのみ「解除」ボタンを表示する。
 *
 * @param {object[]} lockPeriods - LockPeriod の全行
 * @param {function} onUnlock    - (id) => void 解除ボタン押下ハンドラ
 * @param {boolean}  disabled    - 操作中の非活性フラグ
 */
function LockPeriodHistoryTable({ lockPeriods, onUnlock, disabled }) {
  // 開始日が新しい順に並べる
  const sorted = [...lockPeriods].sort((a, b) => b.StartDate.localeCompare(a.StartDate));

  if (sorted.length === 0) {
    return <p className="text-gray-400 text-base">登録されたロック期間はありません。</p>;
  }

  return (
    <div className="overflow-x-auto">
      <table className="border-collapse text-sm">
        <thead>
          <tr>
            <th className="border border-gray-300 px-3 py-2 bg-gray-50 font-normal whitespace-nowrap">期間</th>
            <th className="border border-gray-300 px-3 py-2 bg-gray-50 font-normal whitespace-nowrap">状態</th>
            <th className="border border-gray-300 px-3 py-2 bg-gray-50 font-normal whitespace-nowrap">ロック日時</th>
            <th className="border border-gray-300 px-3 py-2 bg-gray-50 font-normal whitespace-nowrap">操作者</th>
            <th className="border border-gray-300 px-3 py-2 bg-gray-50 font-normal whitespace-nowrap">解除日時</th>
            <th className="border border-gray-300 px-3 py-2 bg-gray-50 font-normal whitespace-nowrap"></th>
          </tr>
        </thead>
        <tbody>
          {sorted.map((p) => {
            const isUnlocked = p.UnlockedAt != null;
            return (
              <tr key={p.id} className="hover:bg-gray-50">
                <td className="border border-gray-300 px-3 py-2 whitespace-nowrap">
                  {formatDateDisplay(p.StartDate)} 〜 {formatDateDisplay(p.EndDate)}
                </td>
                <td className="border border-gray-300 px-3 py-2 whitespace-nowrap">
                  {isUnlocked ? (
                    <span className="text-gray-400">解除済み</span>
                  ) : (
                    <span className="text-red-600 font-medium">ロック中</span>
                  )}
                </td>
                <td className="border border-gray-300 px-3 py-2 whitespace-nowrap">{p.LockedAt}</td>
                <td className="border border-gray-300 px-3 py-2 whitespace-nowrap">{p.LockedBy}</td>
                <td className="border border-gray-300 px-3 py-2 whitespace-nowrap">{p.UnlockedAt ?? ""}</td>
                <td className="border border-gray-300 px-3 py-2 whitespace-nowrap">
                  {!isUnlocked && (
                    <ActionButton
                      label="解除"
                      onClick={() => onUnlock(p.id)}
                      disabled={disabled}
                      paddingClass="px-3 py-1"
                      textSizeClass="text-sm"
                    />
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

export default LockPeriodHistoryTable;
